/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import * as React from "react";
import { TextInputProps } from "./TextInput.types";

export const TextInput = ({
  label,
  value,
  onChange,
  placeholder = "",
  "data-test-id": dataTestId,
  type = "text",
  inputRef,
  onFocus,
}: TextInputProps & {
  inputRef?: React.RefObject<HTMLInputElement>;
  onFocus?: React.FocusEventHandler<HTMLInputElement>;
}): JSX.Element => {
  return (
    <div className="lexical-Input__wrapper">
      <label className="lexical-Input__label">{label}</label>
      <input
        ref={inputRef}
        type={type}
        className="lexical-Input__input"
        placeholder={placeholder}
        value={value}
        onChange={(e) => {
          onChange(e.target.value);
        }}
        data-test-id={dataTestId}
        onFocus={onFocus}
        // Use pointer down for best compatibility
        onPointerDown={e => {
          e.stopPropagation();
          setTimeout(() => {
            inputRef && inputRef.current?.focus();
          }, 0);
        }}
      />
    </div>
  );
};

export default TextInput;